// extracted by mini-css-extract-plugin
export default {"wrapper":"DownloadButton_wrapper__k8PLp","expand":"DownloadButton_expand__7dSrM"};